export interface LogoItem {
  id: string;
  imgSrc: string;
  width?: number | string;
}

export const partners: LogoItem[] = [
  { id: 'logoAgridea', imgSrc: '/assets/img/Logo-Agridea.png' },
  { id: 'logoSG', imgSrc: '/assets/img/logo_sg.jpg' },
];

export const financialSupport: LogoItem[] = [
  { id: 'bafu', imgSrc: '/assets/img/BAFU_dfi_RGB_pos_quer.png', width: 400 },
];

export type LogoGroup = 'partners' | 'financialSupport';

export const logoGroups: Record<LogoGroup, LogoItem[]> = {
  partners,
  financialSupport,
};
